var _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgPwCFunctIconsRotateClockwiseOutlineBlackRgb(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Outline",
    xmlns: "http://www.w3.org/2000/svg",
    viewBox: "0 0 100 100",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M62.09,42.89a2.45,2.45,0,0,0-.72,1.75,2.47,2.47,0,0,0,2.46,2.47H86V24.91a2.47,2.47,0,1,0-4.93,0V38.68h0L69.41,27a32.49,32.49,0,1,0,0,46L65.93,69.5a27.56,27.56,0,1,1,0-39L77.59,42.17H63.83A2.44,2.44,0,0,0,62.09,42.89Z"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgPwCFunctIconsRotateClockwiseOutlineBlackRgb);
export default __webpack_public_path__ + "static/media/PwC_Funct_Icons_RotateClockwise_Outline_Black_RGB.d7aa4d2f7e96c8eb240be6efa471577b.svg";
export { ForwardRef as ReactComponent };